import request from '@/utils/request'

/**
 * 获取所有权限
 * @returns {Promise<{
 *   code: number,
 *   message: string,
 *   data: Array<{
 *     id: number,
 *     permissionName: string,
 *     permissionCode: string,
 *     type: string,
 *     parentId: number,
 *     path: string,
 *     component: string,
 *     sort: number,
 *     icon: string,
 *     status: number,
 *     createTime: string,
 *     updateTime: string
 *   }>
 * }>} 所有权限列表
 */
export function getAllPermissions() {
  return request({
    url: '/permission',
    method: 'get'
  })
}

/**
 * 获取权限详情
 * @param {number} id 权限ID
 * @returns {Promise<{
 *   code: number,
 *   message: string,
 *   data: {
 *     id: number,
 *     permissionName: string,
 *     permissionCode: string,
 *     type: string,
 *     parentId: number,
 *     path: string,
 *     component: string,
 *     sort: number,
 *     icon: string,
 *     status: number,
 *     createTime: string,
 *     updateTime: string
 *   }
 * }>} 权限详情
 */
export function getPermissionById(id) {
  return request({
    url: `/permission/${id}`,
    method: 'get'
  })
}

/**
 * 创建权限
 * @param {Object} data 权限数据
 * @param {string} data.permissionName 权限名称
 * @param {string} data.permissionCode 权限编码
 * @param {string} data.type 权限类型：menu-菜单，button-按钮，api-接口
 * @param {number} [data.parentId=0] 父权限ID，0表示顶级权限
 * @param {string} [data.path] 路由路径，菜单类型必填
 * @param {string} [data.component] 组件路径，菜单类型必填
 * @param {number} [data.sort=0] 排序号
 * @param {string} [data.icon] 图标
 * @param {number} [data.status=1] 状态：1-启用，0-禁用
 * @returns {Promise<{
 *   code: number,
 *   message: string,
 *   data: {
 *     id: number,
 *     permissionName: string,
 *     permissionCode: string,
 *     type: string,
 *     parentId: number,
 *     path: string,
 *     component: string,
 *     sort: number,
 *     icon: string,
 *     status: number,
 *     createTime: string,
 *     updateTime: string
 *   }
 * }>} 创建的权限信息
 */
export function createPermission(data) {
  return request({
    url: '/permission',
    method: 'post',
    data
  })
}

/**
 * 更新权限
 * @param {number} id 权限ID
 * @param {Object} data 权限数据
 * @param {string} data.permissionName 权限名称
 * @param {string} data.permissionCode 权限编码
 * @param {string} data.type 权限类型：menu-菜单，button-按钮，api-接口
 * @param {number} [data.parentId] 父权限ID，0表示顶级权限
 * @param {string} [data.path] 路由路径，菜单类型必填
 * @param {string} [data.component] 组件路径，菜单类型必填
 * @param {number} [data.sort] 排序号
 * @param {string} [data.icon] 图标
 * @param {number} [data.status] 状态：1-启用，0-禁用
 * @returns {Promise<{
 *   code: number,
 *   message: string,
 *   data: {
 *     id: number,
 *     permissionName: string,
 *     permissionCode: string,
 *     type: string,
 *     parentId: number,
 *     path: string,
 *     component: string,
 *     sort: number,
 *     icon: string,
 *     status: number,
 *     createTime: string,
 *     updateTime: string
 *   }
 * }>} 更新后的权限信息
 */
export function updatePermission(id, data) {
  return request({
    url: `/permission/${id}`,
    method: 'put',
    data
  })
}

/**
 * 删除权限
 * @param {number} id 权限ID
 * @returns {Promise<{
 *   code: number,
 *   message: string
 * }>} 删除结果
 */
export function deletePermission(id) {
  return request({
    url: `/permission/${id}`,
    method: 'delete'
  })
}

/**
 * 根据权限类型获取权限列表
 * @param {string} type 权限类型：menu-菜单，button-按钮，api-接口
 * @returns {Promise<{
 *   code: number,
 *   message: string,
 *   data: Array<{
 *     id: number,
 *     permissionName: string,
 *     permissionCode: string,
 *     type: string,
 *     parentId: number,
 *     path: string,
 *     component: string,
 *     sort: number,
 *     icon: string,
 *     status: number,
 *     createTime: string,
 *     updateTime: string
 *   }>
 * }>} 指定类型的权限列表
 */
export function getPermissionsByType(type) {
  return request({
    url: '/permissions/types',
    method: 'get',
    params: { type }
  })
}

/**
 * 获取权限树结构
 * @returns {Promise<{
 *   code: number,
 *   message: string,
 *   data: Array<{
 *     id: number,
 *     permissionName: string,
 *     permissionCode: string,
 *     type: string,
 *     parentId: number,
 *     path: string,
 *     component: string,
 *     sort: number,
 *     icon: string,
 *     status: number,
 *     children: Array<Object>,
 *     createTime: string,
 *     updateTime: string
 *   }>
 * }>} 权限树结构
 */
export function getPermissionTree() {
  return request({
    url: '/permissions/tree',
    method: 'get'
  })
} 